import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  socialShareFB = `${environment.appSocialShare.fb}${environment.appWebUrl}`;

  year: number;
  public isThaiLan = false;
  constructor() { }

  ngOnInit() {
    const userId = localStorage.getItem("UserID");
    if (userId) {
      if (userId.toUpperCase() == "7C3D1F7B-5D41-4E8F-BB25-94477288CD09"
        || userId.toUpperCase() == "F0653360-26D9-45F8-A60A-0C9C5BB6F9EB"
        || userId.toUpperCase() == "C3DB22C3-9691-42CB-872E-DCBC0A9AE213"
        || userId.toUpperCase() == "2FB8A0B9-AE50-4C53-8DF8-7A2041770A34"

      ) {
        this.isThaiLan = true;
      } else {
        this.isThaiLan = false;
      }
    }
    this.year = new Date().getFullYear();
  }
}
